import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.TransactionsList', {
    wallet: 'Wallet',
    createdDate: 'Created Date',
    type: 'Type',
    description: 'Description',
    amount: 'Amount',
    status: 'Status',
    transactionTypeFee: 'Fee',
    transactionTypeConversion: 'Conversion',
    transactionTypePayment: 'Payment',
    transactionTypeFunding: 'Funding',
    transactionDetails: 'Transaction details',
    downloadPaymentConfirmation: 'Download payment confirmation',
});
